import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import SwitchBase from '../SwitchBase';
import IconOn from './IconOn';
import IconOff from './IconOff';
export var StyledSwitchBase = styled(SwitchBase).withConfig({
  displayName: "ui-kit-StyledSwitchBase",
  componentId: "ui-kit-edxox7"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 40px;\n  height: 40px;\n"], ["\n  width: 40px;\n  height: 40px;\n"])));
export var CheckedIcon = styled(IconOn).withConfig({
  displayName: "ui-kit-CheckedIcon",
  componentId: "ui-kit-yiy5kn"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n\n  &.disabled {\n    color: ", ";\n  }\n  input:focus-visible + &:not(.disabled) {\n    border-radius: 3px;\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n"], ["\n  color: ", ";\n\n  &.disabled {\n    color: ", ";\n  }\n  input:focus-visible + &:not(.disabled) {\n    border-radius: 3px;\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.mid;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.muted;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay24;
});
export var Icon = styled(IconOff).withConfig({
  displayName: "ui-kit-Icon",
  componentId: "ui-kit-1eq8ph5"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  stroke: ", ";\n  color: transparent;\n\n  &.disabled {\n    stroke: ", ";\n  }\n  input:focus-visible + &:not(.disabled) {\n    border-radius: 3px;\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n"], ["\n  stroke: ", ";\n  color: transparent;\n\n  &.disabled {\n    stroke: ", ";\n  }\n  input:focus-visible + &:not(.disabled) {\n    border-radius: 3px;\n    box-shadow: 0px 0px 0px 3px ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.mid;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.secondary.muted;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.fill.primary.overlay24;
});
var templateObject_1, templateObject_2, templateObject_3;